import { ILoyaltyCategories, ILoyaltyTiers } from 'state/loyalty/types';

import { QUERY_TYPE } from '../constants';
import { LoyaltyError } from '../exceptions';
import {
  GetLoyaltyCategoryQuery,
  GetLoyaltyGooglePayPass,
  GetLoyaltyOnboardingQuickSelectTierQuery,
  GetLoyaltyTierQuery
} from '../queries/loyalty';

interface IGetLoyaltyGooglePayPass {
  getLoyaltyCardGooglePass: {
    jwt: string;
  };
  errors?: Error[];
}

export const getLoyaltyCardGooglePayPass = (cardId: String) => {
  return {
    queryType: QUERY_TYPE.LambdaGraphqlQuery,
    query: GetLoyaltyGooglePayPass,
    variables: {
      cardId
    },
    then: (data: IGetLoyaltyGooglePayPass) => {
      if (data.errors || !data.getLoyaltyCardGooglePass || !data.getLoyaltyCardGooglePass.jwt) {
        throw data.errors;
      }
      return data.getLoyaltyCardGooglePass.jwt;
    },
    catch: (err: Error) => {
      throw new LoyaltyError('An error occurred loading the loyalty card Google Pay Jwt', err);
    }
  };
};

export const getLoyalty2_0Category = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    query: GetLoyaltyCategoryQuery,
    then: (data: ILoyaltyCategories) => {
      if (data.errors) {
        throw data.errors;
      }

      return data.allLoyaltyConfigurations[0].categories;
    },
    catch: (err: Error) => {
      throw new LoyaltyError(`An error occurred getting loyalty card categories`, err);
    }
  };
};

export const getLoyalty2_0OnboardingQuickSelectTier = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    query: GetLoyaltyOnboardingQuickSelectTierQuery,
    then: (data: ILoyaltyCategories) => {
      if (data.errors) {
        throw data.errors;
      }

      return data.allLoyaltyConfigurations[0].onboardingQuickSelectTiers;
    },
    catch: (err: Error) => {
      throw new LoyaltyError(`An error occurred getting loyalty card categories`, err);
    }
  };
};

export const getLoyalty2_0Tier = () => {
  return {
    queryType: QUERY_TYPE.SanityGraphqlQuery,
    query: GetLoyaltyTierQuery,
    then: (data: ILoyaltyTiers) => {
      if (data.errors) {
        throw data.errors;
      }

      return data.allLoyaltyConfigurations[0].bankMyRewardTier;
    },
    catch: (err: Error) => {
      throw new LoyaltyError(`An error occurred getting loyalty tier`, err);
    }
  };
};
